import './AddArticle.scss';
import Form from '../../Components/Form/Form';

const AddArticle = (props) => {
  return (
    <>
      <Form />
    </>
  );
}

export default AddArticle;